import * as React from "react"
import GridLoader from "react-spinners/GridLoader"
import { PuffLoader } from "react-spinners"
import styled from "styled-components"
import { theme } from "../theme"

interface Props {
  smallSpinner?: boolean
}

const LoaderContainer = styled.div<{ smallSpinner?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${(props) => (props.smallSpinner ? "4px" : "2rem")};
`

const LoadingSpinner: React.FunctionComponent<Props> = ({ smallSpinner }) => (
  <LoaderContainer smallSpinner={smallSpinner}>
    <PuffLoader size={smallSpinner ? 40 : 80} color={theme.colors.purple} />
  </LoaderContainer>
)

export default LoadingSpinner
